import React, { useState, useMemo } from "react";
import { Button, ErrorWithString, SuccessWithString } from "../../../../../components/RegularComponents";

const headers = [
    {
        key: "transactionNumber",
        title: "Transaction ID",
        sort: (isAscending) => (a, b) =>{
            const aStr = a.transactionNumber
            const bStr = b.transactionNumber
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        } 
    },
    {
        key: "transactionDate",
        title: "Payment date",
        sort: (isAscending) => (a, b) => {
            const aStr = `${a.transactionDate} ${a.transactionDate}`
            const bStr = `${b.transactionDate} ${b.transactionDate}`
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        }
    },
    {
        key: "paymentType",
        title: "Payment type",
        sort:(isAscending) => (a, b) => {
            const aStr = `${a.paymentType}`
            const bStr = `${b.paymentType}`
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        }
    },
    {
        key: "transactionStatus",
        title: "Status",
        sort:(isAscending) => (a, b) => {
            const aStr = `${a.transactionStatus}`
            const bStr = `${b.transactionStatus}`
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        },
        format: (status) => {
            return status === "COMPLETED" ?
            (<span className="has-success">{SuccessWithString("Complete", { fontWeight: "bold", fontSize: "1.1rem" })}</span>) :
            (<span className="ns-error-message field-validation-error">{ErrorWithString(status, { fontWeight: "bold", fontSize: "1.1rem" })}</span>)
        }
    },
]

export const PaymentHistoryTable = (props) => {
    const { data, setDetails } = props;

    const [sortingParameters, setSortingParameters] = useState({})

    const rows = useMemo(() => {
        if(!data) { return []}
        const header = headers.find(h => h.key === sortingParameters.key)
        if(!header) { return data }

        const newBranches = [...data]
        newBranches.sort(header.sort(sortingParameters.isAscending));
        return newBranches

    }, [sortingParameters, data])

    const getSortIcon = (header) => {
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        let modifiedSortingParams = { ...sortingParameters }

        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)
    }

    return (
        <div style={{ marginTop: "1em" }}>
            <table>
                <thead>
                    <tr>
                        {headers.map((h) => (
                            <th key={h.key} onClick={headerClicked(h)}>
                                <div style={{
                                    display: "inline-flex",
                                    width: "100%",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    cursor: "arrow",
                                }}><span>{h.title}</span> <span style={{marginRight: "6px"}}>{getSortIcon(h)}</span></div>
                            </th>
                        ))}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>
                            {headers.map((header, headerIndex) => {
                                const key = header.key;
                                const value = row[key]
                                const formattedValue = header.format ? header.format(value) : value;
                                return <td key={headerIndex}>{formattedValue}</td>
                            })}
                            <td>
                                <Button id={`licence-suspension-detail-${index}`}
                                    className={"licence-queue-review-readonly-button"}
                                    buttonType="regular_primary"
                                    text="Details"
                                    onClick={() => {
                                        setDetails(row)
                                    }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    )
}
